import { createApiHandler } from './handler';

const dietCategories = {
  apiClient: null,
  path: '/admin/diet-categories',

  setClient(apiClient) {
    this.apiClient = apiClient;
    this.initApiHandler();
  },

  initApiHandler() {
    Object.assign(this, createApiHandler(this.apiClient, this.path));
  },
};

export default dietCategories;
